import {
  isEmptyString,
  notEmptyString,
} from '@populateui/utils';

export type ModifierSuggestion = {
  code: string;
  label: string;
  description: string;
};

const KX_MODIFIER: ModifierSuggestion = {
  code: 'KX',
  label: 'Consider adding KX modifier',
  description:
    'This visit includes a physical therapy service. For Medicare patients, the KX modifier may be required when the applicable annual therapy threshold has been reached and continued therapy is medically necessary and supported by the medical record. Confirm the requirements are met before adding KX.',
};

const SUGGESTIONS_BY_CPT: Record<string, readonly ModifierSuggestion[]> = {
  '97110': [KX_MODIFIER],
  '97112': [KX_MODIFIER],
  '97140': [KX_MODIFIER],
  '97530': [KX_MODIFIER],
};

type GetModifierSuggestionsParams = {
  serviceCode?: string | null;
  selectedModifierCodes?: readonly (string | null | undefined)[];
};

function normalizeCode(value?: string | null): string {
  return notEmptyString(value) ? (value ?? '').trim().toLowerCase() : '';
}

export function getModifierSuggestions({
  serviceCode,
  selectedModifierCodes = [],
}: GetModifierSuggestionsParams): ModifierSuggestion[] {
  const normalizedServiceCode = normalizeCode(serviceCode);

  if (isEmptyString(normalizedServiceCode)) {
    return [];
  }

  const suggestions = SUGGESTIONS_BY_CPT[normalizedServiceCode] ?? [];
  const selectedCodes = new Set(
    selectedModifierCodes
      .map((code) => normalizeCode(code))
      .filter((code) => notEmptyString(code)),
  );

  return suggestions.filter(
    (suggestion) => !selectedCodes.has(normalizeCode(suggestion.code)),
  );
}
